import { IPetItemResponse } from "../services/pet-list/pet-list.interface";

export const isWellnessMember = (
  petList: IPetItemResponse[] | any[],
  petId: string,
  isRedirect?: boolean,
): boolean | null => {
  const pet = petList.find((p) => p.id === petId);

  if (pet && petList.length === 1 && pet.species === "3" && isRedirect) {
    return true;
  }

  return pet ? pet.isWellnessplan ?? null : null;
};
